/** @jsx createElement */
// Other
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { AnimatedSlide } from '../animated-slide';
import { AppActions } from '../app-actions';
import { PlayerTimeline } from '../players/timeline';

@observer
export class Slide26 extends AnimatedSlide {
  // Animation players
  players = {
    timeline: null,
    events: null,
  };

  /*
  Slide 20-25
  Slide 26 Investigation Summary Provided
  */

  timeline = {
    unit: 'minute',
    units: 49,
    start: 0,
    width: 1000,
    alternate: true,
    details: [
      {
        start: '0:00',
        end: '0:35',
        description: 'Scenario',
        active: true,
      },
      {
        start: '0:00',
        end: '0:35',
        description: 'Attack Stage',
      },
      {
        start: '0:00',
        end: '0:35',
        description: 'Investigation Triggered',
      },
      {
        start: '0:35',
        description: 'Endpoint Investigation',
      },
      {
        start: '0:45',
        description: 'Containment',
      },
      {
        start: '1:52',
        description: 'Analyst Alert',
      },
      {
        start: '2:12',
        description: 'Escalation',
      },
      {
        start: '5:57',
        description: 'Follow-up Investigation Confirmation',
      },
      {
        start: '6:57',
        description: 'Advanced Investigation - Intrusion Vector',
      },
      {
        start: '13:05',
        description: 'Investigation Summary Provided',
      },
      {
        start: '14:05',
        description: 'Advanced Investigation - Post Intrusion Activities',
      },
      {
        start: '47:45',
        end: '49:00',
        description: 'Investigation Summary Provided',
      },
    ],
  };

  // Run the first animation
  componentDidMount() {
    AppActions.hideBackgroundGrid();
    AppActions.hideRightArrow();
    AppActions.disableAppScreenshot();

    this.steps = [
      // Step 1
      () => {},
    ];

    this.animations = [
      // Step 1
      [],
    ];

    // Play the first animation
    this.play();
  }

  componentWillUnmount() {
    AppActions.showBackgroundGrid();
    AppActions.showRightArrow();
    AppActions.enableAppScreenshot();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-23 timeline-slide ${className}`}>
        {children}
        <div className="content">
          <PlayerTimeline
            events={this.timeline.details}
            unit={this.timeline.unit}
            units={this.timeline.units}
            start={this.timeline.start}
            alternate={this.timeline.alternate}
            width={this.timeline.width}
          />
        </div>
      </div>
    );
  }
}
